export const BLANK_IMAGE = './assets/img/websites/image-blank.svg';
